import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function UgovornoPravoPM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Ugovorno pravo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Ugovorno pravo</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Ugovorno pravo
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Ugovorno pravo je upoznavanje studenata sa
                ugovornim pravom kao jednom od najznačajnijih grana u opštem
                sistemu obligacionog prava, kao i sa pojmom, vrstama i izvorima
                ugovornih odnosa koji se regulišu domaćim i međunarodnim
                normama. Cilj predmeta je i da studenti izuče posebne vrste
                ugovornih odnosa između određenih lica, kao i da povežu stečena
                znanja u cilju osposobljavanja za primjenu znanja u praksi.
                Takođe izučavanjem ovog predmeta steći će produbljena znanja iz
                oblasti Ugovornog prava, kao i iz oblasti međunarodnih ugovora.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješno savladanog predmeta Ugovorno pravo, studenti će
                biti u mogućnosti da definišu i analiziraju osnovna načela
                ugovornog prava, izvore obligacija, osnovne institute ugovornog
                prava, kao i da uoče sličnosti i razlike rješenja domaćeg
                pozitivnog prava sa rješenjima u uporednom pravu. Takođe,
                studenti će biti u mogućnosti da definišu, analiziraju i objasne
                pravne karakteristike ugovora, uslove nastanka, dejstvo, načine
                i uslove prestanka, obezbjeđenje i izmjene ugovornih odnosa.
                Nakon savladanog predmeta, studenti će biti u mogućnosti da
                sačine različite vrste ugovora te da analizom teksta različitih
                ugovora identifikuju i objasne osnovne elemente sadržine
                pomenutih ugovora.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Definisanje pojma ugovora, sadržina ugovornog
                odnosa, pojam i značaj ugovornog prava, izvori ugovornih odnosa,
                zaštita ugovornog odnosa, principi slobode ugovaranja, pojam
                opštih uslova za nastanak ugovora, poslovna sposobnost
                ugovorenika, forma i tumačenje ugovora, dejstvo ugovora,
                prestanak ugovora, raskidanje ugovora, poništavanje ugovora,
                protok vremena i otkaz, smrt jedne strane, gašenje obligacionog
                odnosa, ispunjenje, prebijanje, oproštaj duga, prenos,
                sjedinjenje, prouzrokovanje štete drugome, neosnovano bogaćenje,
                vršenje poslova bez naloga, pojam i vrste i osnovi odgovornosti
                za štetu, ugovorne rezerve, izmjena ugovora, međunarodni ugovori
                Crne Gore, postupak zaključenja ugovora: pregovori, ponuda,
                prihvatanje ponude, pripemni sporazum, ugovor. Praktična
                nastava: Analiza sudske prakse, debate, pisanje ugovora,
                razvijanje tehnika za zaključivanje ugovora, analiza sudske
                prakse, analiza svakodnevnih situacija i pronalaženje modaliteta
                njihovog rješavanja.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: Predavanja, vježbe,
                konsultacije, pismene provjere znanja (kolokvijumi),
                individualni rad studenata (seminarski i domaći radovi, referati
                i sl.), kao i grupno učestvovanje studenata na savlađivanju
                određenih tematskih jedinica.
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 1V</td>
                    <td>
                      Definisanje pojma ugovora, sadržina ugovornog odnosa
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 1V</td>
                    <td>
                      Pojam i značaj ugovornog prava, izvori ugovornih odnosa
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 1V</td>
                    <td>
                      Zaštita ugovornog odnosa, principi slobode ugovaranja,
                      pojam opštih uslova za nastanak ugovora
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 1V</td>
                    <td>
                      Poslovna sposobnost ugovorenika, forma i tumačenje
                      ugovora, dejstvo ugovora
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 1V</td>
                    <td>Prestanak ugovora, raskidanje ugovora</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 1V</td>
                    <td>
                      Poništavanje ugovora, protok vremena i otkaz, smrt jedne
                      strane
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 1V</td>
                    <td>
                      Gašenje obligacionog odnosa, ispunjenje, prebijanje,
                      oproštaj duga, prenos, sjedinjenje
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 1V</td>
                    <td>Prouzrokovanje štete drugome</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 1V</td>
                    <td>Neosnovano bogaćenje, vršenje poslova bez naloga</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 1V</td>
                    <td>Pojam i vrste i osnovi odgovornosti za štetu</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 1V</td>
                    <td>Ugovorne rezerve, izmjena ugovora</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 1V</td>
                    <td>Međunarodni ugovori Crne Gore</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 1V</td>
                    <td>
                      Postupak zaključenja ugovora: pregovori, ponuda,
                      prihvatanje ponude, pripemni sporazum, ugovor
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5č / 3.45h</td>
                            <td>Ukupno: 90h</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4č / 3h</td>
                            <td>Nastava + završni ispit: 65h</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 10h</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15h</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UgovornoPravoPM;
